import { Basket } from './components/basket'
import { Chat } from './components/chat'
import { Notification } from './components/notification'
import type { IButtonBadgeProps } from './types'

export const ButtonBadge = {
  Basket: Basket,
  Chat: Chat,
  Notification: Notification,
}

export type { IButtonBadgeProps }
